import React, { useContext, Fragment } from "react";
import PropTypes from "prop-types";
import schema from "../schema.js";

import { StoreContext } from "../context/StoreContext";
import { types } from "../context/reducers";

import Forms from "../components/Forms";

import Log from "../Log";

const Home = (props) => {
  const { dispatch } = useContext(StoreContext);

  const submitForm = (questionAnswers) => {
    dispatch({
      type: types.SET_ANSWERS,
      payload: questionAnswers,
    });

    props.history.push({
      pathname: "/result",
    });
  };

  const traceLog = (update) => {
    Log.trace("Form update: ", update);
  };

  return (
    <React.Fragment>
      <section className="jumbotron text-center">
        <div className="container">
          <h1 className="jumbotron-heading">
            Data Rights for California Residents
          </h1>
          <p className="lead">
            CONSUMER RIGHTS GIVEN TO CALIFORNIA CONSUMERS UNDER THE CALIFORNIA
            CONSUMER PRIVACY ACT OF 2018 (THE “CCPA”) as amended.
          </p>
          <p>
            <b>Please note:</b> The right to request your information is
            reserved for CALIFORNIA RESIDENTS ONLY. You may exercise your Data
            Rights by making a request here, or by calling{" "}
            <em>(855) 210-9448.</em>
          </p>
        </div>
      </section>
      <section className="request">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Forms
                schema={schema}
                onUpdate={traceLog}
                onSubmit={submitForm}
                disableSubmit
              />
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

Home.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default Home;
